import { partnerUrl, performReq } from '../api'

export const getDebugWhitelist = ({ partnerId }) => {
  return performReq('GET', partnerUrl(partnerId) + '/trackedids')
}

export const getUserByEmail = ({ partnerId, partialEmail }) => {
  return performReq('GET', partnerUrl(partnerId) + `/trackedids/user-by-email?email=${encodeURIComponent(partialEmail)}`)
}
